/** Only show countdown when target date is within this many days */
export const COUNTDOWN_MAX_DAYS = 20;
const COUNTDOWN_MAX_MS = COUNTDOWN_MAX_DAYS * 24 * 60 * 60 * 1000;

export function shouldShowCountdown(targetDate: Date | null): boolean {
  if (!targetDate) return false;
  const now = Date.now();
  const target = targetDate.getTime();
  return target > now && target - now <= COUNTDOWN_MAX_MS;
}
